<app-header titulo="VENTA EN DON RAFAEL" [mensaje]="barra"></app-header>

<div class="flex">
  <div class="flex column-direction between-spacer listado-venta">
    <table class="table table-bordered mt-1">
      <thead class="table-dark">
        <tr>
          <th>Nombre</th>
          <th>Un/Kg</th>
          <th>Precio</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let producto of service.productos; let i = index"
          class="text-black"
          (click)="opcionesProducto(i)"
        >
          <td>
            <strong>{{ producto.name }}</strong>
          </td>

          <td id="cantidad_{{ i }}" class="text-right">
            <strong>{{
              producto.kilo > 10
                ? (producto.cantidad | number : "1.1-1")
                : (producto.cantidad | number)
            }}</strong>
          </td>

          <td class="text-right">
            <strong>{{
              (producto.kilo > 10 ? producto.kilo : producto.precio) | number
            }}</strong>
          </td>

          <td class="text-right">
            <strong>{{
              (producto.kilo > 10
                ? producto.precio
                : producto.precio * producto.cantidad
              ) | number
            }}</strong>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="total">
      <h1>{{ this.service.venta | currency : "USD" : "symbol" : "1.0-0" }}</h1>
    </div>
  </div>

  <div class="flex column-direction listado-opciones">
    <app-opciones></app-opciones>
  </div>
</div>

<!-- Modal Opciones Productos-->
<div
  class="modal fade"
  id="modelOpciones"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modelTitleId"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-opciones-contenido">
        <h2 class="nombre-producto">
          {{ qtyForm.controls.producto.value.name }}
        </h2>

        <form
          *ngIf="
            qtyForm.controls.producto.value.category === 'ABARROTES' ||
            qtyForm.controls.producto.value.category === 'PASTELERIA'
          "
          [formGroup]="qtyForm"
          class="flex center-center"
        >
          <button class="btn-menos" (click)="restar()">-</button>
          <input class="input-opciones-qty" type="text" formControlName="qty" />
          <button class="btn-mas" (click)="sumar()">+</button>
        </form>

        <button
          *ngIf="
            qtyForm.controls.producto.value.category === 'ABARROTES' ||
            qtyForm.controls.producto.value.category === 'PASTELERIA'
          "
          class="btn-aceptar"
          (click)="setearQty()"
        >
          ACEPTAR
        </button>
        <button class="btn-eliminar" (click)="quitarProducto()">
          ELIMINAR
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer *ngIf="this.service.caja" [texto]="version"></app-footer>
